<div class="container-fluid ptCustom">

    <div class="my-2">
        <a [routerLink]="['/admin-portal/chamber/pending-news']" class="text-white"><i
                class="fa-regular fa-angle-left"></i> back to all pending news</a>
    </div>

    <div class="row">

        <div class="col-lg-8 col-md-8 my-2">
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader">
                            <h4>{{newsInfo.articleTitle}}</h4>
                            <a href="javascript:void(0);" (click)="openEditModal()"><i
                                    class="fa-regular fa-pencil"></i></a>
                        </div>
                        <div class="detailsSection">
                            <div class="row">
                                <div class="col">
                                    <div class="detailsBlock introLetterContent">
                                        <div class="pendingNewsPhotoContainer">
                                            <img src={{newsInfo.mainImageUrl}} alt="featured image"
                                                class="pendingNewsPhotoImg" />
                                        </div>
                                        <div [innerHTML]="newsInfo.articleContent"></div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-4 col-md-4 my-2">
            <div class="card shadow-sm rounded-lg mb-3">
                <div class="card-body p-4">
                    <div class="detailsContainer">
                        <div class="detailsHeader justify-content-center">
                            <h4>Review Letter</h4>
                        </div>
                        <div class="detailsSection">
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Member</span>
                                </div>
                                <div class="dataOutput">
                                    <span class="d-block">{{newsInfo.memberName}}</span>
                                    <small class="text-muted">{{newsInfo.memberCompany}}</small>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Posting Under</span>
                                </div>
                                <div class="dataOutput">
                                    <span class="d-block">{{newsInfo.postingAs}}</span>
                                </div>
                            </div>
                            <div class="detailsBlock">
                                <div class="dataLabel">
                                    <span>Previous News Submissions</span>
                                </div>
                                <div class="dataOutput">
                                    <span class="d-block">{{newsInfo.previousSubmissions}} Total</span>
                                    <small *ngIf="newsInfo.previousSubmissions != 0" class="text-muted fst-italic">last
                                        on {{newsInfo.lastSubmissionDate}}</small>
                                </div>
                            </div>
                            <div *ngIf="!newsInfo.isClosed">
                                <div class="mb-3">
                                    <input [(ngModel)]="newsInfo.approverNotes" type="text" class="form-control"
                                        id="exampleNotes" placeholder="Notes">
                                </div>
                                <div class="mb-4">
                                    <a href="javascript:void(0);" (click)="PublishArticle(1)" type="button"
                                        class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i>
                                        approve article</a>
                                </div>
                                <div class="text-center">
                                    <a href="javascript:void(0);" (click)="PublishArticle(2)"
                                        class="text-white"><small>reject article</small></a>
                                </div>
                            </div>
                            <div *ngIf="newsInfo.isClosed">
                                <div class="detailsBlock">
                                    <div class="dataLabel">
                                        <span>Status</span>
                                    </div>
                                    <div class="dataOutput">
                                        <span class="d-block">{{newsInfo.status}}</span>
                                    </div>
                                </div>
                                <div class="mb-3">
                                    <input [(ngModel)]="newsInfo.approverNotes" type="text" class="form-control"
                                        id="exampleNotes" placeholder="Notes">
                                </div>
                                <div class="mb-4">
                                    <a href="javascript:void(0);" (click)="PublishArticle(1)" type="button"
                                        class="btn btn-add text-strong hvr-grow w-100"><i class="fa-solid fa-check"></i>
                                        approve article</a>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="card shadow-sm rounded-lg">
                <div class="card-body p-4" *ngIf="newsInfo.attachmentInfo?.length > 0">
                    <div class="attachmentWrap">
                        <div *ngFor="let attachment of newsInfo.attachmentInfo; index as ind" class="attachmentBlock"
                            (click)="DownloadAttachment(ind)">
                            <div class="fileType">
                                <i class="fa-regular" [ngClass]="CommonLibrary.GetFileIconClass(attachment.type)"></i>
                            </div>
                            <div class="fileInfo">
                                <span class="fileTitle">
                                    {{attachment.name}}
                                </span>
                                <span class="fileSize">
                                    {{attachment.sizeInBytes}}
                                </span>
                            </div>
                            <!--<div class="fileActions">-->
                            <!--<a href="javascript:void(0);" class="mb-1"><i class="fa-regular fa-pen-to-square"></i></a-->
                            <!--<a (click)="removeAttachment(ind)" class="text-danger"><i class="fa-regular fa-times"></i></a>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-end footerWrap">
                <section id="admin-footer">
                </section>
            </div>
        </div>

        <!-- == PLUGINS == -->
        <!-- jquery -->
        <script type="text/javascript" src="../js/jquery-3.6.3.min.js"></script>
        <!-- datatables -->
        <script type="text/javascript" src="../js/plugins/datatables/datatables.min.js"></script>
        <!-- fontawesome -->
        <script type="text/javascript" src="../js/plugins/fontawesome/all.js"></script>
        <!-- mobiscroll -->
        <script type="text/javascript" src="../js/plugins/mobiscroll/mobiscroll.jquery.min.js"></script>
        <!-- bootstrap -->
        <script type="text/javascript" src="../bootstrap/js/bootstrap.bundle.min.js"></script>
        <!-- files -->
        <script type="text/javascript" src="../js/header.js"></script>

        <script type="text/javascript">

            // active menu item
            function activeMenuItem() {
                document.getElementById("pending-news").setAttribute("id", "activePage");
            }

            // typeahead search hub
            $('#filter-select').mobiscroll().select({
                inputElement: document.getElementById('filter-input'),
                touchUi: false,
                theme: 'ios',
                themeVariant: 'dark',
                display: 'anchored',
                filter: true,
                context: '#editArticle',
            });

        </script>